import Consts from './consts/adminConsts'

export default class {

    Id = "";
    FullName = "Не указан";
    Rights = Consts.UserRights.find(e => e.Id == 0);
    DAX = "";
    Email = "";
    Status = Consts.UserStatus.find(e => e.Id == 0);

    mapFromDto(user) {
        this.Id = user ? user.Id : '';
        this.FullName = user ? user.FullName : 'Не указан';
        this.Rights = user ? Consts.UserRights.find(e => e.Id == user.Rights) : Consts.UserRights.find(e => e.Id == 0);
        this.DAX = user ? user.DAX : '';
        this.Email = user ? user.Email : '';
        this.Status = user ? Consts.UserStatus.find(e => e.Id == user.Status) : Consts.UserStatus.find(e => e.Id == 0);
        
        return this;
    }

}